import classNames from 'classnames';
import FormErrorMessage from 'components/FormErrorMessage';
import { Toggle } from 'components/Toggle/Toggle';
import get from 'lodash/get';

const ToggleField = ({
  block,
  disabled,
  hideStateMessage,
  id,
  input,
  label,
  labelPosition,
  messages,
  meta,
  msg,
  name,
  wrapStyle,
  wrapperClassName = '',
}) => {
  const touched = get(meta, 'touched');
  const error = get(meta, 'error');
  return (
    <div
      style={wrapStyle}
      className={classNames(
        block ? 'block' : 'inline-block',
        wrapperClassName,
        'align-middle',
      )}
    >
      <Toggle
        {...input}
        id={id}
        name={name}
        disabled={disabled}
        messages={messages}
        hideStateMessage={hideStateMessage}
        label={label}
        labelPosition={labelPosition}
      />
      {touched && error && (
        <FormErrorMessage>
          {get(msg, ['validation', error], 'Error')}
        </FormErrorMessage>
      )}
    </div>
  );
};

export default ToggleField;
